<template>
  <div class="user_list_item">
    <div class="item left">
      <div class="name">{{ data.nickname }}</div>
      <div class="bottom">
        <user-label :label="label" :gender="data.gender" :age="data.age"/>
      </div>
    </div>
    <div class="item center">
      <div>{{ certType }}</div>
      <div>{{ data.cert }}</div>
    </div>
    <div class="item right">
      <div class="edit" @click="handlerClick"><i class="fa fa-edit"></i></div>
    </div>
  </div>
</template>

<script>
import userLabel from './userLabel.vue'

export default {
  name: 'user-list-item',
  props: ['data', 'label'],
  data () {
    return {
      certType: ''
    }
  },
  components: {
    userLabel
  },
  created () {
    this.certType = this.data.cert_type === 2 ? '护照' : '身份证'
  },
  methods: {
    handlerClick () {
      this.$emit('edit')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  .user_list_item {
    padding: rem(5) 3%;
    height: rem(90);
    border-bottom: 1px #e5e5e5 solid;
    font-size: rem(26);
    color: #333;
    display: flex;
    justify-content: space-between;
    /*align-items: center;*/
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .left {
      width: rem(150);
      .name {
        height: rem(30);
        font-size: rem(25);
      }
    }
    .center {
      width: rem(300);
    }
    .right {
      width: rem(70);
      .edit {
        /*color: #5abaed;*/
        width: rem(50);
        text-align: center;
        font-size: rem(30);
      }
    }
  }
</style>
